import Image from "next/image";
import BlogCard from "../BlogCard/BlogCard";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Thumbnail from "../BlogCard/thumbnail.png";

const BlogHome = () => {
  const carddata = [
    {
      thumbnail: "https://cdn.mytakbir.com/blogs/mytakbir-Welcome-to-Takbir-A-Place-to-Learn-Teach-and-Grow-bolg-one.webp",
      title: "Welcome to Takbir – A Place to Learn, Teach, and Grow in Knowledge",
      //onClick:onClick,
      link: "https://blog.mytakbir.com/post/welcome-takbir-learn-teach-grow",
    },
    {
      thumbnail: "https://cdn.mytakbir.com/blogs/mytakbir-First-10-Things-to-Do-as-a+New-Muslim-Convert-bolg-two.webp",
      title: "First 10 Things to Do as a New Muslim Convert",
      //onClick:onClick,
      link: "https://blog.mytakbir.com/post/things-to-do-as-a-new-muslim",
    },

    {
      thumbnail: "https://cdn.mytakbir.com/blogs/mytakbir-Halal-and-Haram-Food-in-Islam-A-Complete-Guide-bolg-three.webp",
      title: "Halal Food and Haram Food in Islam: A Complete Guide",
      //onClick:onClick,
      link: "https://blog.mytakbir.com/post/halal-haram-food",
    },
  ];

  return (
    <>
      <Container maxWidth="lg" sx={{paddingBottom:"24px",}}>
        <Typography
          gutterBottom
          variant="h5"
          component="div"
          sx={{
            fontSize: "34px",
            color: "#001233",
            fontWeight: 700,
            lineHeight: "28px",
            marginBottom: "24px",
            textAlign:"center",
            marginTop:"52px",
          }}
        >
          Latest From Our Blog
        </Typography>

        <BlogCard 
          col="4" 
          buttonlabel="Read More" 
          carddata={carddata}
          buttoncolor="#004FE0"
          thumbnailHeight={200} 
        />
      </Container>
    </>
  );
};

export default BlogHome;
